import React from "react";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import * as Icons from "lucide-react";
import { specials, businessInfo } from "../data/mock";
import { printCoupon } from "../lib/printCoupon";

const Specials = () => {
  return (
    <section id="specials" className="py-20 md:py-24 bg-slate-50 bg-grid">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-5 gap-10 items-start">
          <div className="lg:col-span-2">
            <Badge className="bg-green-50 text-green-700 border border-green-200 hover:bg-green-50 mb-4">Specials</Badge>
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight leading-tight">
              Save today — <span className="text-green-600">this week only.</span>
            </h2>
            <p className="text-slate-600 mt-4 text-lg">
              Mention this page or take a screenshot at checkout. Combine with our Price Match Guarantee for the best smog check deal in Marin County.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Button asChild className="bg-green-600 hover:bg-green-700 text-white font-bold">
                <a href={businessInfo.bookingUrl} target="_blank" rel="noreferrer">Claim Discount</a>
              </Button>
              <Button variant="outline" className="border-slate-300" onClick={printCoupon}>
                Print Coupon
              </Button>
            </div>
          </div>

          <div className="lg:col-span-3 grid sm:grid-cols-2 gap-4">
            {specials.map((sp) => {
              const Icon = Icons[sp.icon] || Icons.BadgePercent;
              return (
                <Card key={sp.title} className="card-hover border border-slate-200 rounded-xl bg-white">
                  <CardContent className="p-6">
                    <div className="w-11 h-11 rounded-lg bg-green-600 text-white grid place-items-center mb-4">
                      <Icon className="w-5 h-5" />
                    </div>
                    <h3 className="font-black text-slate-900 mb-1.5">{sp.title}</h3>
                    <p className="text-sm text-slate-600 leading-relaxed">{sp.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specials;
